import axios from 'axios';
import { stringify } from 'qs';
import config from '../Config';
let apiCancelToken = axios.CancelToken.source();
export const cancelApiCalls = () => {
    if (apiCancelToken) {
        apiCancelToken.cancel();
    }
    apiCancelToken = axios.CancelToken.source();
};
export const API_CONF = {
    baseURL: config.apiUrl,
    timeout: 10000,
    withCredentials: config.credentialsAllowed,
    headers: { Pragma: 'no-cache' },
    paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' })
};
class APIWrapper {
    constructor() {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: axios.create(API_CONF)
        });
        Object.defineProperty(this, "requestsDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, requestConfig) => {
                return this.axios.get(url, this.getConfig(requestConfig));
            }
        });
        Object.defineProperty(this, "delete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, requestConfig) => {
                return this.axios.delete(url, this.getConfig(requestConfig));
            }
        });
        Object.defineProperty(this, "head", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, requestConfig) => {
                return this.axios.head(url, this.getConfig(requestConfig));
            }
        });
        Object.defineProperty(this, "post", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, data, requestConfig) => {
                return this.axios.post(url, data, this.getConfig(requestConfig));
            }
        });
        Object.defineProperty(this, "put", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, data, requestConfig) => {
                return this.axios.put(url, data, this.getConfig(requestConfig));
            }
        });
        Object.defineProperty(this, "getConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (requestConfig) => {
                const tempConfig = { ...API_CONF, ...requestConfig };
                if (!('cancelToken' in tempConfig)) {
                    tempConfig.cancelToken = apiCancelToken.token;
                }
                return tempConfig;
            }
        });
    }
    initializeInterceptors(ssoStore) {
        this.axios.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            const errorResponse = error === null || error === void 0 ? void 0 : error.response;
            if (errorResponse && errorResponse.status === 401) {
                this.requestsDisabled = true;
                cancelApiCalls();
                ssoStore.doLogout();
            }
            return Promise.reject(error);
        });
        this.axios.interceptors.request.use((value) => {
            if (this.requestsDisabled) {
                return {
                    headers: {},
                    method: value.method,
                    baseURL: '',
                    url: ''
                };
            }
            return value;
        });
    }
}
const API = new APIWrapper();
export default API;
